module.exports = __webpack_public_path__ + "static/media/bitcoin-circle.71bc666f.svg";